const doneActionsOutput = {
  title: `Acciones concluidas`,
  title1: `Acciones vencidas`,
  title2: `Acciones por vencer`
};

export default doneActionsOutput;
